// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_rj7","cls2":"server_side_bulk_downloader-cls2_BcH server_side_bulk_downloader-cls1_rj7"};